export default "__VITE_ASSET__0RwMZ9Xn__"